import { useLingui } from "@lingui/react";

import { getRewardMultiplier } from "../../engine/scoring";
import { gradeText } from "../../i18n/enumText";
import type { Grade } from "../../types";
import { cx } from "./cx";
import type { ClassValue } from "./cx";
import styles from "./GradeSeal.module.css";

const toneClass: Record<Grade, ClassValue> = {
  S: styles.gradeS,
  A: styles.gradeA,
  B: styles.gradeB,
  C: styles.gradeC,
  Failed: styles.gradeFailed,
};

export type GradeSealSize = "default" | "large";

export interface GradeSealProps {
  grade: Grade;
  score?: number;
  showMultiplier?: boolean;
  size?: GradeSealSize;
  className?: string;
}

export function GradeSeal({
  grade,
  score,
  showMultiplier = false,
  size = "default",
  className,
}: GradeSealProps): JSX.Element {
  const { i18n } = useLingui();
  return (
    <div className={cx(styles.seal, styles[size], className)}>
      <div className={cx(styles.letter, toneClass[grade])}>{i18n._(gradeText(grade))}</div>
      {(score !== undefined || showMultiplier) && (
        <div className={styles.meta}>
          {score !== undefined && <span className={styles.score}>{score}</span>}
          {showMultiplier && (
            <span className={styles.multiplier}>×{getRewardMultiplier(grade)}</span>
          )}
        </div>
      )}
    </div>
  );
}
